import React from 'react';

export const TaskDetailLoadingState = () => {
    return (
        <div className="row ticket-detail-layout px-2 px-md-3" aria-busy="true" aria-live="polite">
            <div className="col-12 col-xxl-9 order-1 order-xxl-1 ticket-detail-main-col pt-2">
                <div className="d-flex flex-wrap gap-2 mb-2" aria-hidden="true">
                    <span className="ticket-skeleton-line ticket-skeleton-line--md" />
                    <span className="ticket-skeleton-line ticket-skeleton-line--sm" />
                </div>

                <div className="card card__no-border ticket-detail-wrapper mb-3">
                    <div className="card-body px-3 py-2">
                        <div className="ticket-detail-header mb-3">
                            <div className="ticket-detail-header__content d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3">
                                <div>
                                    <i className="bi bi-arrow-left" aria-hidden="true" />
                                </div>

                                <div className="w-100 d-flex flex-column gap-2">
                                    <span className="ticket-skeleton-line ticket-skeleton-line--lg" />
                                    <div className="d-flex flex-wrap align-items-center gap-2">
                                        <span className="ticket-skeleton-line ticket-skeleton-line--md" />
                                        <span className="ticket-skeleton-line ticket-skeleton-line--sm" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="ticket-detail-main-tabs mb-3">
                            <div className="nav flex-row flex-wrap ticket-detail-top-tabs">
                                <button type="button" className="nav-link active" disabled>General</button>
                                <button type="button" className="nav-link" disabled>Clasificación</button>
                            </div>
                        </div>

                        <div className="tab-content border rounded p-3">
                            <div className="d-flex flex-column gap-3">
                                <div>
                                    <label className="form-label">Título</label>
                                    <span className="ticket-skeleton-line d-block" style={{ height: '36px' }} />
                                </div>

                                <div>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <label className="form-label mb-0">Descripción</label>
                                        <button type="button" className="btn btn-light-brand btn-sm" disabled>Editar descripción</button>
                                    </div>
                                    <div className="" style={{ minHeight: '110px' }}>
                                        <span className="ticket-skeleton-line ticket-skeleton-line--lg d-block mb-2" />
                                        <span className="ticket-skeleton-line ticket-skeleton-line--md d-block mb-2" />
                                        <span className="ticket-skeleton-line ticket-skeleton-line--lg d-block" />
                                    </div>
                                </div>

                                <div className="card card__no-border mt-3">
                                    <div className="card-body p-0">
                                        <h6 className="fw-semibold mb-3">Seguimientos / Resolución</h6>

                                        <div className="border rounded p-3 mb-3 bg-light">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <label className="form-label mb-0">Nuevo seguimiento</label>
                                                <span className="badge bg-soft-success text-success">PÚBLICO</span>
                                            </div>

                                            <div className="border rounded p-2" style={{ minHeight: '110px' }}>
                                                <span className="ticket-skeleton-line ticket-skeleton-line--lg d-block mb-2" />
                                                <span className="ticket-skeleton-line ticket-skeleton-line--lg d-block mb-2" />
                                                <span className="ticket-skeleton-line ticket-skeleton-line--md d-block" />
                                            </div>

                                            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-2">
                                                <button type="button" className="ticket-file-input__trigger" disabled>
                                                    <i className="bi bi-paperclip" aria-hidden="true" />
                                                    Adjuntar archivos
                                                </button>
                                                <button type="button" className="btn btn-primary" disabled>Enviar</button>
                                            </div>
                                        </div>

                                        <div className="ticket-follows-panel">
                                            <div className="ticket-follows-panel__toolbar">
                                                <div className="ticket-follows-panel__tabs">
                                                    <button type="button" className="ticket-follows-panel__tab is-active" disabled>Conversación (0)</button>
                                                    <button type="button" className="ticket-follows-panel__tab" disabled>Públicas (0)</button>
                                                    <button type="button" className="ticket-follows-panel__tab" disabled>Privadas (0)</button>
                                                </div>

                                                <div className="ticket-follows-panel__actions">
                                                    <button type="button" className="ticket-follows-panel__sort-btn" disabled>
                                                        <i className="bi bi-funnel me-1" aria-hidden="true" />
                                                        Ordenar por: Más reciente
                                                        <i className="bi bi-chevron-down ms-1" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="d-flex flex-column gap-3">
                                                {[1, 2].map((item) => (
                                                    <div key={`follow-skeleton-${item}`} className="ticket-follow-item">
                                                        <span className="ticket-skeleton-line" style={{ width: '42px', height: '42px', borderRadius: '50%' }} />
                                                        <div className="ticket-follow-item__body">
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <span className="ticket-skeleton-line ticket-skeleton-line--md" />
                                                                <span className="ticket-skeleton-line ticket-skeleton-line--sm" />
                                                            </div>
                                                            <span className="ticket-skeleton-line ticket-skeleton-line--lg d-block mb-2" />
                                                            <span className="ticket-skeleton-line ticket-skeleton-line--lg d-block" />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ticket-detail-bottom-actions px-4 mt-2">
                    <div className="ticket-detail-bottom-actions__inner">
                        <div className="ticket-detail-bottom-actions__status d-flex align-items-center gap-2">
                            <label className="form-label me-2">Estatus</label>
                            <span className="ticket-skeleton-line d-block" style={{ width: '160px', height: '34px' }} />
                        </div>
                        <div className="d-flex gap-2">
                            <span className="ticket-skeleton-line d-block" style={{ height: '34px', width: '96px' }} />
                            <span className="ticket-skeleton-line d-block" style={{ height: '34px', width: '110px' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 col-xxl-3 order-2 order-xxl-2 mt-3 mt-xxl-0">
                <div className="ticket-detail-sidebar-scroll">
                    <div className="ticket-sidebar-accordion">
                        <div className="ticket-sidebar-accordion__item">
                            <div className="ticket-sidebar-accordion__trigger">
                                <span>Propiedades del ticket</span>
                                <i className="bi bi-chevron-up" aria-hidden="true" />
                            </div>
                            <div className="ticket-sidebar-accordion__body">
                                <div className="ticket-summary-list mt-1">
                                    {['Estado', 'Tipo', 'Prioridad', 'Vencimiento', 'Cliente', 'Proyecto'].map((label) => (
                                        <div className="ticket-summary-item" key={`summary-skeleton-${label}`}>
                                            <div className="ticket-summary-item__label">{label}</div>
                                            <span className="ticket-skeleton-line ticket-skeleton-line--md d-block" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="ticket-sidebar-accordion__item">
                            <div className="ticket-sidebar-accordion__trigger">
                                <span>Información del solicitante</span>
                                <i className="bi bi-chevron-up" aria-hidden="true" />
                            </div>
                            <div className="ticket-sidebar-accordion__body">
                                <div className="row g-2">
                                    {['Solicitante', 'Asignado a', 'Grupo'].map((label) => (
                                        <div className="col-12" key={`requester-skeleton-${label}`}>
                                            <label className="form-label">{label}</label>
                                            <span className="ticket-skeleton-line d-block" style={{ height: '34px' }} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="ticket-sidebar-accordion__item">
                            <div className="ticket-sidebar-accordion__trigger">
                                <span>Adjuntos y etiquetas</span>
                                <i className="bi bi-chevron-up" aria-hidden="true" />
                            </div>
                            <div className="ticket-sidebar-accordion__body">
                                <div className="mb-3">
                                    <label className="form-label">Adjuntos</label>
                                    <span className="ticket-skeleton-line ticket-skeleton-line--lg d-block mb-2" />
                                    <span className="ticket-skeleton-line ticket-skeleton-line--md d-block" />
                                </div>

                                <div>
                                    <label className="form-label">Etiquetas</label>
                                    <div className="input-group input-group-sm">
                                        <span className="ticket-skeleton-line d-block" style={{ height: '34px' }} />
                                        <span className="ticket-skeleton-line" style={{ width: '42px', height: '34px', borderRadius: '8px' }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};